// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__Aglx6","container":"index_container__3wF-M","btn-forgot":"index_btn-forgot__2LlsI","divider":"index_divider__2PRN0","mini-icon":"index_mini-icon__1dvQA"};